import { requestJson } from '../../../shared/api/http'
import type { TrendIndexResponse, TrendReport } from '../model/contracts'

export async function fetchLatestTrend(signal?: AbortSignal): Promise<TrendReport> {
  return requestJson<TrendReport>('/api/v1/trends/latest', {
    method: 'GET',
    signal,
  })
}

export async function fetchTrendIndex(signal?: AbortSignal): Promise<TrendIndexResponse> {
  return requestJson<TrendIndexResponse>('/api/v1/trends/index', {
    method: 'GET',
    signal,
  })
}
